export const DISCARDED_NOTIFICATIONS_KEY = 'ASP::Notifications::Discarded';
